export default __webpack_public_path__ + "static/media/remove-green-icon.2e9b6cb1.svg";